import withStore, { TLoadingAwarePresenter, TPresentable } from "../withStore";
import Application from "../../Application";
import { IReportingPeriod } from "../../model/reporting/ReportingPeriod";
import ReportingPeriodApplicantPresentationModel, {
  TReportingPeriodApplicantPresentationModel
} from "../../model/applicant/ReportingPeriodApplicantPresentationModel";
import { IReportingPeriodApplicant } from "../../model/applicant/ReportingPeriodApplicant";
import { RoleConstants } from "../../common/Constants";
import { ApplicationService } from "../../service/ApplicationService";

export interface TReportingPeriodDetailsPresenter extends TLoadingAwarePresenter {
  reportingPeriod: IReportingPeriod;
  reportingPeriodApplicants: TReportingPeriodApplicantPresentationModel[];
}

export interface IReportingPeriodDetailsPresenter
  extends TReportingPeriodDetailsPresenter, TPresentable {
  setReportingPeriod(reportingPeriod: IReportingPeriod): void;
  setReportingPeriodApplicants(
    reportingPeriodApplicants: IReportingPeriodApplicant[]
  ): void;
  showApplicantDetails(applicantId: number): void;
  canShowApplicantDetails(): boolean;
}

const defaultState: TReportingPeriodDetailsPresenter = {
  reportingPeriod: {} as IReportingPeriod,
  reportingPeriodApplicants: []
};

const ReportingPeriodDetailsPresenter = withStore<
  IReportingPeriodDetailsPresenter,
  TReportingPeriodDetailsPresenter
>(
  ({
    application,
    store,
    loader,
    translate
  }): IReportingPeriodDetailsPresenter => {
    const _store = store;
    const _application: Application = application;
    const state = _store.getState<TReportingPeriodDetailsPresenter>();
    loader.start("applicantsLoader");

    const setReportingPeriod = (reportingPeriod: IReportingPeriod) => {
      _store.update({ reportingPeriod });
    };

    const setReportingPeriodApplicants = (
      reportingPeriodApplicants: IReportingPeriodApplicant[]
    ) => {
      _store.update({
        reportingPeriodApplicants: reportingPeriodApplicants.map(
          ReportingPeriodApplicantPresentationModel
        )
      });
      loader.stop("applicantsLoader");
    };

    const onRenderBreadcrumbLabel = (id: string) => {
      const state = _store.getState<TReportingPeriodDetailsPresenter>();
      return state.reportingPeriod.name;
    };
    _store.update({
      breadCrumb: {
        ...(_store.getState() as any).breadCrumb,
        reportingPeriodId: onRenderBreadcrumbLabel
      }
    });

    const showApplicantDetails = (applicantId: number) => {
      const state = _store.getState<TReportingPeriodDetailsPresenter>();
      const reportingPeriodId = state.reportingPeriod.id;
      _application.navigator.push({
        pathname: `/reporting-periods/${reportingPeriodId}/registered-applicants/${applicantId}/details`
      });
    };

    const canShowApplicantDetails = () => {
      const { roles } = _store.getState() as any;
      return ApplicationService().hasAnyRole(
        [
          RoleConstants.MIK_BO.MIK_OSOBLJE,
          RoleConstants.MIK_BO.MIK_OSOBLJE_PDNS
        ],
        roles
      );
    };

    return {
      ...state,
      store: _store,
      loader,
      application: _application,
      translate,
      setReportingPeriod,
      setReportingPeriodApplicants,
      showApplicantDetails,
      canShowApplicantDetails
    };
  },
  defaultState
);

export default ReportingPeriodDetailsPresenter;
